import { render } from "./theme36.vue?vue&type=template&id=09b36764&scoped=true"
import script from "./theme36.vue?vue&type=script&lang=js"
export * from "./theme36.vue?vue&type=script&lang=js"

import "./theme36.vue?vue&type=style&index=0&id=09b36764&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-09b36764"

export default script